export const na = 'N/A';
export const footerLinks = {
    about: 'About Ask-AI',
    support: 'Support',
};
export const Logo = 'Logo';
export const Error = 'Error';
